import React, { useState } from 'react'
import { Col, Row, Card, Button, Form } from '@themesberg/react-bootstrap'
import { inject, observer } from 'mobx-react'


import Select from '../../ui/Dropdown'
import * as XLSX from 'xlsx';

const customStyles = {
	control: (base) => ({
		...base,
		background: '#e7e3f9',
		height: 44,
		minHeight: 44,
		minWidth: 100,
		width: 240,
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			return {
				...styles,
				backgroundColor: '#c3b9f1',
			}
		},
	}),
	multiValue: (styles, { data }) => {
		return {
			...styles,
			backgroundColor: '#c3b9f1',
		}
	},
}
export default inject('zigna_aiStore','providerPriceCompareStore')(
	observer(({ providerPriceCompareStore,  billingCodeType, setBillingCodeType, hideModifier, actionFunc, showAggMeasure, showExport, hideProcCategoty,zigna_aiStore,setFilterSet ,filterSet}) => {
	
		const downloadExcel = (data) => {
			const worksheet = XLSX.utils.json_to_sheet(data);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
			//let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
			//XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
			XLSX.writeFile(workbook, "DataSheet.xlsx");
		  };

		

//const [filterSet,setFilterSet]=useState([])
const [hasChanges,setHasChanges]=useState(false)
const updateFilterSet=(field,value)=>{
	zigna_aiStore?.resetProviderExtractChartResult()
	setHasChanges(true)
	let index=filterSet.findIndex(i=>i.field==field)
	let updatedFilerset=[]
	if(index>-1){
		updatedFilerset=[...filterSet.slice(0,index)]
	}
	else{
		updatedFilerset=[...filterSet]
	}
if(value?.name?.length||value?.length)	
setFilterSet([...updatedFilerset,{field,value}])
else
setFilterSet([...updatedFilerset])
}

const refetchFilterData=(items,codeType)=>{
	
	
		if(items){
			zigna_aiStore.getProviderExtractFilters({billingCodeType:codeType||billingCodeType,filters:items.map(i=>{
				return({
					field:i.field,
					value:i.field=="region"?i.value.name:i.value?.map(j=>j.name)
				})
			})})
		}else{
			if(hasChanges){
			zigna_aiStore.getProviderExtractFilters({billingCodeType:codeType||billingCodeType,filters:filterSet.map(i=>{
				return({
					field:i.field,
					value:i.field=="region"?i.value.name:i.value?.map(j=>j.name)
				})
			})})
		}
		}

setHasChanges(false)
}


const onSubmitForm=()=>{
	zigna_aiStore.getProviderExtractResultsCharts({
		billingCodeType:billingCodeType,
		fields:filterSet.map(i=>{
		return({
			field:i.field,
			value:i.field=="region"?i.value.name:i.value?.map(j=>j.name)
		})
	})})
}

		return (
			<Card border="light" className="shadow-sm filterSection">
				<Card.Body>
					<h5>
						Filter{' '}
						{ showExport && (<span className="downloadBtn ">
							<svg
								width="20"
								height="20"
								viewBox="0 0 123 121"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clipPath="url(#clip0_4_39)">
									<path
										d="M84.58 47C85.2961 46.2624 86.1525 45.6755 87.0988 45.2737C88.0451 44.872 89.0621 44.6635 90.0902 44.6607C91.1182 44.6578 92.1364 44.8605 93.0849 45.257C94.0335 45.6534 94.8931 46.2355 95.6133 46.9691C96.3336 47.7026 96.8998 48.5728 97.2788 49.5285C97.6578 50.4841 97.8418 51.5059 97.82 52.5337C97.7983 53.5615 97.5712 54.5746 97.1522 55.5133C96.7332 56.4521 96.1306 57.2975 95.38 58L66.09 86.88C64.6464 88.2981 62.7036 89.0927 60.68 89.0927C58.6564 89.0927 56.7136 88.2981 55.27 86.88L26.4 58.37C24.9413 56.9365 24.1118 54.9823 24.094 52.9372C24.0762 50.8921 24.8715 48.9237 26.305 47.465C27.7385 46.0063 29.6927 45.1768 31.7378 45.159C33.7829 45.1412 35.7513 45.9365 37.21 47.37L53.1 63.12L53.26 7.65C53.3468 5.65118 54.2063 3.76414 55.6572 2.38657C57.1081 1.009 59.0371 0.248502 61.0378 0.265358C63.0384 0.282213 64.9544 1.0751 66.3818 2.47692C67.8093 3.87874 68.6369 5.78 68.69 7.78L68.54 62.78L84.58 47ZM0 113.48L0.1 83.3C0.0733066 82.2639 0.255513 81.233 0.635757 80.2689C1.016 79.3047 1.58649 78.427 2.31323 77.688C3.03996 76.9491 3.90804 76.364 4.86573 75.9677C5.82341 75.5715 6.85109 75.3721 7.88748 75.3815C8.92387 75.3909 9.94776 75.6089 10.8981 76.0225C11.8484 76.4361 12.7058 77.0368 13.419 77.7888C14.1322 78.5408 14.6866 79.4288 15.0493 80.3997C15.412 81.3706 15.5755 82.4046 15.53 83.44L15.46 105.44C46.1267 105.5 76.7633 105.5 107.37 105.44L107.44 83.32C107.459 81.2725 108.29 79.3163 109.751 77.8816C111.212 76.447 113.183 75.6514 115.23 75.67C117.277 75.6886 119.234 76.5197 120.668 77.9806C122.103 79.4415 122.899 81.4125 122.88 83.46L122.78 113.46H122.69C122.6 115.432 121.758 117.294 120.337 118.663C118.916 120.032 117.023 120.804 115.05 120.82C79.23 120.887 43.4367 120.887 7.67 120.82C5.69389 120.814 3.79555 120.049 2.36785 118.683C0.940148 117.317 0.0923821 115.454 0 113.48H0Z"
										fill="#B54491"
									/>
								</g>
								<defs>
									<clipPath id="clip0_4_39">
										<rect width="122.88" height="120.89" fill="white" />
									</clipPath>
								</defs>
							</svg>
							<span className="ml-5" onClick={()=>downloadExcel(providerPriceCompareStore.priceDiffAvgList?.data)}>Download</span>
						</span>)}
					</h5>
					<Row>
					<Col className=" col-auto col-auto">
							<div
								className="mb-3"
								
							>
								<label className="form-label">
									Billing code type<span className="text-danger">*</span>
								</label>
								<Select
									className={`select-menu
									}`}
									value={{id:billingCodeType,name:billingCodeType,value:billingCodeType}}
									options={[
									{id:"CPT",name:"CPT",value:"CPT"},
									{id:"HCPCS",name:"HCPCS",value:"HCPCS"}]}
									onChange={(e) => {
										setFilterSet([])
										refetchFilterData([],e.name)
										setBillingCodeType(e.name)
										
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									closeMenuOnSelect={true}
									// onMenuClose={
									// 	()=>refetchFilterData()
									// }
								/>
							</div>
						</Col>
						<Col className=" col-auto col-auto">
							<div
								className="mb-3"
								
							>
								<label className="form-label">
									Region<span className="text-danger">*</span>
								</label>

								<Select
									className={`select-menu
									}`}
									value={filterSet.find(i=>i.field=="region")?.value||null}
									options={zigna_aiStore.providerExtractFilters.region?.map(i=>({id:i.name,value:i.name,name:i.name}))||[]}
									onChange={(e) => {
										
										refetchFilterData([{field:"region",value:e}])
									   updateFilterSet("region",e)
										
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									closeMenuOnSelect={true}
									// onMenuClose={
									// 	()=>refetchFilterData()
									// }
								/>
							</div>
						</Col>
						<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">
									Level 1 Description
								</label>
								<div className="d-flex align-items-center h45 NPI-select">
								<Select
									className={`select-menu`}
									aria-label="Default select example"
									isDisabled={!filterSet.find(i=>i.field=="region")?.value}
									onChange={(e,data) => {
										
											updateFilterSet("level1_description",e)
										}
									
                                  
										
										 
									 }
									value={
										filterSet.find(i=>i.field=="level1_description")?.value||null
										}
										isMulti
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
										onMenuClose={
											()=>refetchFilterData()
										}
										options={
											zigna_aiStore.providerExtractFilters.level1_description?.length
												? [ ...(zigna_aiStore.providerExtractFilters.level1_description.map(i=>({id:i.name,value:i.name,name:i.name})) || [])]
												: []
										}
										allowSelectAll={true}
										
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
							
						
								/>
								
									</div>
							</div>
						</Col>
						<Col className=" col-auto col-auto">
							<div className="mb-3">
							<label className="form-label">Billing Code<span className="text-danger">*</span><small>&nbsp;(Select upto 100 codes)</small></label>
								<div className="d-flex align-items-center h45 NPI-select">
									<Select
										className={`select-menu`}
										value={filterSet.find(i=>i.field=="billing_code")?.value||null}
										isDisabled={!filterSet.find(i=>i.field=="region")?.value}
										onChange={(e,data) => {
											
												updateFilterSet("billing_code",e)
											
										
									  
											
											 
										 }}
										isMulti
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
									    
										options={
											zigna_aiStore.providerExtractFilters.billing_code?.length
												? [...(zigna_aiStore.providerExtractFilters.billing_code.map(i=>({id:i.name,value:i.name,name:i.name})) || [])]
												: []
										}
										allowSelectAll={true}
										
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
									
										onMenuClose={
											()=>refetchFilterData()
										}
									/>

								</div>
								{/* <label style={{
			marginTop: 5,
			fontSize: 12,
			maxWidth: 275,
			fontStyle: 'italic'
		}}>Please select less than 20 billing codes at a time for better performance.</label> */}
							</div>
						</Col>
					<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">Modifiers</label>
								<div className="d-flex align-items-center h45 NPI-select">
								<Select
									className={`select-menu`}
									aria-label="Default select example"
									isDisabled={!filterSet.find(i=>i.field=="region")?.value}
								value={filterSet.find(i=>i.field=="billing_code_modifier")?.value||null}
								onChange={(e,data) => {
								
										updateFilterSet("billing_code_modifier",e)
									}
								
							  
									
									 
								 }
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									isMulti
									
									
										options={
											zigna_aiStore.providerExtractFilters.billing_code_modifier?.length
												? [...zigna_aiStore.providerExtractFilters.billing_code_modifier.map(i=>({id:i.name,value:i.name,name:i.name}))]
												: []
										}
										allowSelectAll={true}
									
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
										onMenuClose={
											()=>refetchFilterData()
										}
								/>
								
								</div>
							</div>
						</Col>
					
						<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">
								Place Of Service 
								</label>
								<div className="d-flex align-items-center h45 NPI-select">
								<Select
									className={`select-menu`}
									aria-label="Default select example"
									isDisabled={!filterSet.find(i=>i.field=="region")?.value}
									value={
										filterSet.find(i=>i.field=="service_code")?.value||null
										}
									isMulti
									getOptionLabel={(option) => `${option.name}`}
									onChange={(e,data) => {
										
											updateFilterSet("service_code",e)
										}
									
								  
										
										 
									 }
									onMenuClose={
										()=>refetchFilterData()
									}
									
									styles={customStyles}
									options={
										zigna_aiStore.providerExtractFilters.service_code?.length
											? [...(zigna_aiStore.providerExtractFilters.service_code.map(i=>({id:i.name,value:i.name,name:i.name})) || [])]
											: []
									}
									allowSelectAll={true}
									
									closeMenuOnSelect={false}
									hideSelectedOptions={false}
									
								
								
								/>
										
									</div>
								
							</div>
						</Col>
						
						{/* <Col className=" col-auto col-auto">
							<div className="mb-3">
								<label className="form-label">Payer Name</label>
									<div className="d-flex align-items-center h45 NPI-select">
									<Select
										className={`select-menu`}
										value={filterSet.find(i=>i.field=="reporting_entity_name")?.value||null}
										isDisabled={!filterSet.find(i=>i.field=="region")?.value}
										onChange={(e,data) => {
											if (data.option?.value == 'All') {
												updateFilterSet("reporting_entity_name",zigna_aiStore.providerExtractFilters.reporting_entity_name.map(i=>({id:i.name,value:i.name,name:i.name})))
												selectAllPayerName.value = 'D-All'
											} else if (data.option?.value == 'D-All') {
												selectAllPayerName.value = 'All'
												updateFilterSet("reporting_entity_name",[])
											} else {
												if (
													e
														.sort((a, b) =>
															a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
														)
														.toString() !=
														zigna_aiStore.providerExtractFilters.reporting_entity_name.map(i=>({id:i.name,value:i.name,name:i.name}))
														.flat()
														.sort((a, b) =>
															a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
														)
														.toString()
												) {
													selectAllPayerName.value = 'All'
												} else {
													selectAllPayerName.value = 'D-All'
												}
												updateFilterSet("reporting_entity_name",e)
											}
										
									  
											
											 
										 }}
										onBlur={() => {
											if(providerPriceCompareStore?.reportingEntityNameList?.length){
												//providersCPTExtractStore.getProceduresCatList()
											}
										}}
										isMulti
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
										onMenuClose={
											()=>refetchFilterData()
										}
										options={
											zigna_aiStore.providerExtractFilters.reporting_entity_name?.length
												? [ selectAllPayerName,...zigna_aiStore.providerExtractFilters.reporting_entity_name.map(i=>({id:i.name,value:i.name,name:i.name}))]
												: []
										}
										allowSelectAll={true}
										components={{
											Option,
											MultiValue,
											animatedComponents,
										}}
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
										
									/>
									
								</div>
							</div>
						</Col> */}
						
					
						
						
					
						
						<Col className=" col-auto">
							<label className="form-label">{'   '}</label>
							<div className="d-flex align-item-center">
								<Button
									variant="primary"
									size="sm"
									className="submitFilter"
									disabled={!filterSet.find(i=>i.field=="billing_code")?.value?.length}
									onClick={(e) => {
										onSubmitForm()
									}}
									type="button"
								>
									Submit
								</Button>
							</div>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		)
	})
)
